import SUBROUTES from '../subroutes'
import {useMemo} from 'react'
import {useIntl} from 'react-intl'
import {getMyStokkeLabels} from '../../../utils/site-utils'
import useOcapiSite from '../../../hooks/useOcapiSite'
import {useD2BCustomer} from '../../../hooks/use-d2b-customer'

const useMyStokkeSubroutes = () => {
    const {myStokkeConfig} = useOcapiSite()
    const {formatMessage} = useIntl()
    const isD2BEnabled = useD2BCustomer().enabled

    return useMemo(
        () =>
            SUBROUTES.map((route) => {
                const routeConfig = myStokkeConfig[route.configId]
                if (routeConfig) {
                    const config = {
                        ...routeConfig
                    }
                    config.headline = getMyStokkeLabels(
                        routeConfig?.id,
                        'headline',
                        formatMessage,
                        isD2BEnabled
                    )
                    config.subline = getMyStokkeLabels(
                        routeConfig?.id,
                        'subline',
                        formatMessage,
                        isD2BEnabled
                    )
                    return {
                        ...route,
                        config
                    }
                }
                return {
                    ...route,
                    config: routeConfig
                }
            }),
        [myStokkeConfig, formatMessage, isD2BEnabled]
    )
}

export default useMyStokkeSubroutes
